import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { NgModel } from '@angular/forms';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';

import { BaseFilterCollapse, BaseFilterCollapseService } from '../../../core';
import { areasSituacoes } from '../situacao';
import { AreaFilter } from './area-filter';
import { AreaFilterStorageService } from './area-filter-storage.service';

@Component({
    selector: 'sgt-area-filter',
    templateUrl: './area-filter.component.html',
    styleUrls: ['./area-filter.component.less']
})
export class AreaFilterComponent implements BaseFilterCollapse, OnInit, AfterViewInit, OnChanges, OnDestroy {
    @Input() filter: AreaFilter;

    filterPsqSubscription: Subscription;
    isFilterInitializing = false;
    isFilterInitialized = false;
    @Output() filterInitialized = new EventEmitter<any>();
    @Output() filterChange = new EventEmitter<any>();
    @Output() filterCleaned = new EventEmitter<any>();


    // Filter collapse
    @Input() isCollapsedInDefault = false;
    isCollapsedIn = false;
    @ViewChild('filterCollapse') filterCollapse: ElementRef;
    collapseIcon = 'fas fa-caret-down';

    isFirstChangeFilterPsq = true;
    @ViewChild('filterPsq', {static: true}) filterPsq: NgModel;

    /** Situações */
    situacoes = areasSituacoes;

    constructor(private baseFilterCollapseService: BaseFilterCollapseService,
                private areaFilterStorageService: AreaFilterStorageService) { }


    ngOnInit() {
        // Aplicando o filtro salvo no storage
        this.areaFilterStorageService.applyFilter(this.filter);
        // Iniciando filtro
        this.initFilter();
    }

    ngAfterViewInit() {
        if (!this.isCollapsedInDefault) {
            jQuery(this.filterCollapse.nativeElement).css('display', 'none');
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        for (const propName in changes) {
            if (propName === 'isCollapsedInDefault') {
                if (changes[propName].isFirstChange()) {
                    setTimeout(() => {
                        this.isCollapsedIn = changes[propName].currentValue;
                    }, 100);
                }
            }
        }
    }

    /** Inicializa o filtro */
    private initFilter() {
        this.isFilterInitializing = true;
        this.isFilterInitialized = false;

        // Filter de pesquisa
        this.subscribeToFilterPsq();

        this.isFilterInitializing = false;
        this.isFilterInitialized = true;
        this.filterInitialized.emit();
    }

    // Realiza o subscribe nas alterações feitas no input do filtro da pesquisa
    private subscribeToFilterPsq() {
        this.filterPsqSubscription = this.filterPsq.valueChanges
            .pipe(
                debounceTime(1000), // Dando um debounce de 1000ms para emitir a alteração
                map(emittedValue => emittedValue?.trim()),
                distinctUntilChanged()
            )
            .subscribe(() => {
                if (this.isFirstChangeFilterPsq) {
                    this.isFirstChangeFilterPsq = false;
                    return;
                }

                if (this.filter.filterPsq?.trim().length > 0) {
                    this.filter.isFilterDirty = true;
                }

                this.filterChange.emit();
            });
    }

    /** Emite evento de alteração no filtro para atualizar a pesquisa */
    refresh() {
        this.close();
        this.filterChange.emit();
    }

    /** Limpa o filtro e atualiza a pesquisa */
    clear() {
        // Removendo os filtros
        this.baseFilterCollapseService.clear(this);
        this.close();
        this.filterCleaned.emit();
    }

    /** Abre/Fecha o filtro */
    toggleCollapse() {
        this.baseFilterCollapseService.toggleCollapse(this);
    }

    /** Abre o filtro */
    open() {
        this.baseFilterCollapseService.open(this);
    }

    /** Fecha o filtro */
    close() {
        this.baseFilterCollapseService.close(this);
    }

    /** Ao alterar as situações */
    onChangeSituacoes() {
        this.filter.isFilterDirty = true;
        this.filterChange.emit();
    }

    ngOnDestroy() {
        this.filterPsqSubscription?.unsubscribe();
    }
}
